import SegmentImageDetailModel from './SegmentImageDetailModel'
import SegmentImageDetailRenderer from './SegmentImageDetailRenderer'
import SegmentDetail from './SegmentDetail'

export default {
  install( molten ) {
    molten.addPlugin( 'Model', { type : SegmentImageDetailModel.TYPE, model : SegmentImageDetailModel } )
    molten.addPlugin( 'DetailRenderer', { type : SegmentImageDetailModel.TYPE, renderer : SegmentImageDetailRenderer } )
    molten.addPlugin( 'Detail', SegmentDetail )
  }
}
